import { useLayoutEffect, useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Scrolls to top on EVERY navigation — including clicks that go to the
 * same path the user is already on (e.g. footer "Shift Room" while on
 * /membership). We key off location.key which changes on every push.
 */
export default function ScrollToTop() {
  const location = useLocation();
  const navType = useNavigationType(); // POP | PUSH | REPLACE

  // Disable the browser's auto scroll restoration on mount
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useLayoutEffect(() => {
    // Respect in-page anchors
    if (location.hash) return;

    // On real back/forward (POP) let the browser restore if the user wants.
    // For PUSH / REPLACE always force to top.
    if (navType === "POP") return;

    const forceTop = () => {
      try {
        window.scrollTo(0, 0);
      } catch {
        window.scroll(0, 0);
      }
      if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
      if (document.documentElement) document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
    };

    forceTop();
    const r1 = requestAnimationFrame(() => {
      forceTop();
      requestAnimationFrame(forceTop);
    });
    return () => cancelAnimationFrame(r1);
  }, [location.key, location.hash, navType]);

  return null;
}
